import React, { useReducer, useContext, useEffec, useMemo } from 'react'
import { lockedReducer } from '../../Utils/reducers'
import { api } from '../../../services/api'
import ColorButton from '../../Buttons/ColorButton';
import DefaultModal from '../../Utils/DefaultModal';
import toast from 'react-hot-toast'
import dayjs from 'dayjs'
import { Box, Tooltip, TextField } from '@mui/material'
import validateData from './validateData';
import { externalComponent } from '../../AppRoutes';
import { NumbersOnly } from '../../Utils/IntegerOnly'
import { CnpfMask } from '../../Utils/MaskedInput'
import Table, { TableHook } from '../../Table';
import { getSession } from '../../../contexts/auth';
import { maskedTable } from '../../Utils/MaskedInput';

const url = '/people/'


const columns = (setState, permissions) => {
    return [
        { field: 'name', headerName: 'Nome', flex: 1, filterType: 'string' },
        {
            field: 'cnpj', headerName: 'CNPJ', flex: 1, filterType: 'string', renderCell: ({ value }) =>
                maskedTable.cpfcnpj({ value: value ? NumbersOnly(value) : '' })
        },
        { field: 'phone_numbers', headerName: 'Telefone', flex: 1, filterType: 'string' },
        { field: 'status', headerName: 'Status', flex: 1, filterType: 'string' },
        {
            field: 'history_date', headerName: 'Data de modificação', flex: 1, filterType: 'daterange',
            valueGetter: ({ value }) => dayjs(value).toDate().toLocaleString()
        },
    ]
}

const ViewHistoricalPeopleModal = ({ data, handleClose, permissions, reloadData }) => {

    const user = getSession()

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        rows: []
    })

    const [table, reloadTable] = TableHook()

    return (
        <>
            <DefaultModal
                title={
                    `Histórico de alterações`
                }
                dialogProps={{
                    maxWidth: 'md'
                }}
                handleClose={handleClose}
                content={
                    <>
                        <Box className='information-table historic'>
                            <Box className='user-table'>
                                <Table
                                    rows={state.rows}
                                    columns={useMemo(() => columns(setState, user.permissions), [user.permissions])}
                                    pagination
                                    density='compact'
                                    slots={{
                                        filterComponent: true,
                                    }}
                                    toolbar
                                    getRowId={row => row.history_id}
                                    getURL={url + data.id + '/historic/'}
                                    updateRows={(rows) => setState({ 'rows': rows })}
                                    innerRef={table}
                                    mobile={true}
                                    mobileProps={
                                        {
                                            title: ['name']
                                        }
                                    }
                                />
                            </Box>
                        </Box>
                    </>
                }
            />
        </>
    )
}

export default ViewHistoricalPeopleModal